



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { SEARCH_TYPE } from '@/types'
import _get from 'lodash/get'

@Component({})
export default class SearchInput extends Vue {
  public keyword: string = ''
  public $refs: any = {
    keyword: HTMLFormElement,
  }

  @Prop({ required: false })
  public initKeyword: string | undefined

  @Prop({ required: false })
  public searchType: string | undefined

  @Prop({ default: '' })
  public readonly helperText: string | undefined

  @Prop()
  public placeholder: string | undefined

  @Prop({ required: true })
  public readonly toastText: string | undefined

  private showClear: boolean = false

  @Watch('initKeyword')
  private initKeywordChanged(newVal: string) {
    if (newVal !== this.keyword) {
      this.keyword = newVal
    }
  }

  @Watch('keyword')
  private keywordChanged(newVal: string | undefined) {
    if (newVal) {
      this.showClear = false
    }
  }

  private mounted(): void {
    this.$refs.keyword.$el.focus()
  }

  private destroyed(): void {}

  private validateKeyword(): void {
    this.keyword = this.keyword.trim()
    if (this.searchType === SEARCH_TYPE.BOOK_SEARCH_BY_ISBN) {
      const keywordLength = _get(this.keyword, 'length')
      if (keywordLength >= 10) {
        this.showClear = true
        this.$emit('submit', this.keyword)
      } else {
        if (this.toastText) {
          Vue.$toast.error(this.toastText)
        }
      }
    } else {
      this.showClear = true
      this.$emit('submit', this.keyword)
    }
  }

  private clearKeyword(): void {
    this.keyword = ''
    this.validateKeyword()
    this.showClear = false
  }
}
